import { Link } from 'gatsby';
import React from 'react';
import * as tags from './_header.tags';
import { SECTION_IDS } from '~/constants';
import headerRerootsLogo from '~/assets/header/reroots_logo_navy.svg';
import hamburgerIcon from '~/assets/header/hamburger_icon.svg';

type Props = {
  readonly onHamburderMenuClick: () => void;
};

export const Header: React.FC<Props> = ({ onHamburderMenuClick }) => {
  return (
    <tags.StickyHeaderWrapper>
      <tags.NavContainer>
        <tags.HamburgerButton onClick={onHamburderMenuClick}>
          <tags.HamburgerButtonIcon src={hamburgerIcon} alt="メニュー" />
        </tags.HamburgerButton>
        <Link to={`#${SECTION_IDS.TOP}`}>
          <tags.RerootsLogo>
            <tags.RerootsLogoIcon src={headerRerootsLogo} alt="Re roots" />
          </tags.RerootsLogo>
        </Link>
      </tags.NavContainer>
      <Link to={`/#${SECTION_IDS.CONTACT}`} style={{ textDecoration: 'none' }}>
        <tags.Contact>
          <tags.ContactText>CONTACT</tags.ContactText>
        </tags.Contact>
      </Link>
    </tags.StickyHeaderWrapper>
  );
};
